const CPA_ACC_TYPES = {
    BASE: 1,
    BASE_CID: 2,
    COMPLETE: 3
};

export default CPA_ACC_TYPES;
